export default require('../table/Input').default.concat();